import React, { useEffect, useRef } from "react";

// Radno mesto podjedinice (nivo 4-6); nivo se čita iz jedinice, ne hardkoduje.
function SubUnitDesignation({
  position,
  validationError,
  handleChangeDesignationName,
  subUnit,
  setShowDescription,
  handleUpdateDesignation,
  handleShowDescription,
  handleSetEditDesignation,
  handleDeleteDesignation,
  showDescription,
  hasDesignationPermission,
}) {
  const designationRef = useRef();

  useEffect(() => {
    if (designationRef.current) {
      designationRef.current.style.height = "100%";
      const scrollHeight = designationRef.current.scrollHeight;
      designationRef.current.style.height = scrollHeight + "px";
    }
  }, [position]);

  return (
    <li key={`designation${position.id}`}>
      <div
        className={
          !validationError?.level && validationError?.id === position.id
            ? "add-to-list-input-wrapper unit-error-border"
            : "add-to-list-input-wrapper"
        }
      >
        <textarea
          ref={designationRef}
          rows="1"
          autoFocus
          style={{ resize: "none", overflow: "hidden" }}
          readOnly={!position.typing && !position.editing}
          type="text"
          className="add-to-list-input"
          value={position?.name}
          onChange={(e) =>
            handleChangeDesignationName(
              e,
              position.id,
              subUnit.id,
              "sub_units",
              "name"
            )
          }
        ></textarea>

        <div className="edit-buttons-block">
          {(position?.typing || position.editing) && position?.name && (
            <button
              onClick={() => {
                setShowDescription(null);
                handleUpdateDesignation({
                  ...position,
                  level: subUnit.level,
                });
              }}
            >
              <img src="/images/check1.jpg" />
            </button>
          )}
          {!position?.typing &&
            !position.editing &&
            position?.name &&
            hasDesignationPermission && (
              <button
                onClick={() => {
                  handleShowDescription(position.id, subUnit.level, true);
                  handleSetEditDesignation(
                    position.id,
                    subUnit.id,
                    "sub_units",
                    subUnit.level
                  );
                }}
              >
                <img src="/images/edit.png" />
              </button>
            )}
          {hasDesignationPermission && (
            <button
              onClick={() =>
                handleDeleteDesignation(
                  { id: position.id, level: subUnit.level },
                  "designation"
                )
              }
            >
              <img src="/images/trash.png" />
            </button>
          )}
          {!position.adding && (
            <button
              onClick={() => handleShowDescription(position.id, subUnit.level)}
            >
              <img
                alt=""
                src={
                  showDescription &&
                  showDescription.id === position.id &&
                  showDescription.level === subUnit.level
                    ? "/images/iks.png"
                    : "/images/plus.png"
                }
              />
            </button>
          )}
        </div>
      </div>
      {showDescription &&
        showDescription.id === position.id &&
        showDescription.level === subUnit.level && (
          <textarea
            rows="4"
            cols="50"
            className="position-description"
            value={position.description || ""}
            readOnly={!position.editing}
            onChange={(e) =>
              handleChangeDesignationName(
                e,
                position.id,
                subUnit.id,
                "sub_units",
                "description"
              )
            }
          />
        )}
    </li>
  );
}

export default SubUnitDesignation;
